// extracted by mini-css-extract-plugin
module.exports = {"FBPaper":"Paper_FBPaper__fl9q7"};